import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { capitalize } from 'lodash';
import { getOrgTermsContent } from '../../../content/utils.js';
import AuthorizedAction from '../../AuthorizedAction.js';
import FieldGroup from '../../FieldGroup.jsx';
import { INITIATIVE_TYPES } from '../../../lib/schema.js';

function InitiativeCategoryForm({ initiativeType }) {
  return (
    <Row>
      <Col xs={12}>
        <Field
          id="name"
          name="name"
          label="Name"
          placeholder="Enter a Category Name"
          type="text"
          component={FieldGroup}
        />
      </Col>
      <Col xs={12}>
        <Field
          id="initiativeType"
          name="initiativeType"
          label={`${getOrgTermsContent('initiative')} Type`}
          componentClass="select"
          component={FieldGroup}
          disabled={initiativeType}
        >
          <option value="" disabled>
            - Select a {getOrgTermsContent('initiative')} Type -
          </option>
          {INITIATIVE_TYPES.map((type) => (
            <AuthorizedAction action="update" subject={`${type}Initiative`}>
              <option key={type} value={type}>
                {capitalize(type)}
              </option>
            </AuthorizedAction>
          ))}
        </Field>
      </Col>
    </Row>
  );
}

export default InitiativeCategoryForm;
